import React, { useState } from "react";
import styled from "styled-components";
import filter from "../../../assets/filter.png";
import SearchBar from "../../common/Search/SearchBar";

const Wrapper = styled.div`
  @media (max-width: 768px) {
    padding-top: 50px;
  }
`;

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  background-color: #fffef9;
  border-bottom: 1px solid #ddd;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
`;

const LeftSection = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    width: 100%;
    justify-content: space-between;
  }
`;

const PrefixText = styled.div`
  font-size: 18px;
  color: #002e3b;
  font-weight: 600;
  margin-left: 25px;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

const Title = styled.div`
  font-size: 18px;
  color: #ff9f1f;
  font-weight: bold;
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;

  img {
    width: 40px;
    height: 40px;
    margin-top: 5px;
  }
`;

const Button = styled.button`
  display: flex;
  align-items: center;
  background-color: #6ab8a8;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 6px 12px;
  cursor: pointer;
  font-size: ${(p) => (p.$withDropdown ? "inherit" : "15px")};
  position: relative;

  img {
    margin-left: 10px;
    width: 20px;
    height: 20px;
  }

  span {
    font-size: ${(p) => (p.$withDropdown ? "18px" : "20px")};
    margin-left: ${(p) => (p.$withDropdown ? "10px" : "8px")};
  }
`;

const Dropdown = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  background: white;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  min-width: 200px;
  max-height: 300px;
  overflow-y: auto;
  margin-top: 5px;
`;

const DropdownItem = styled.div`
  padding: 10px 15px;
  cursor: pointer;
  border-bottom: 1px solid #f0f0f0;
  color: black;

  &:hover {
    background-color: #f5f5f5;
  }

  &:last-child {
    border-bottom: none;
  }
`;

const SearchBarWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-right: 37px;

  @media (max-width: 768px) {
    width: 100%;
    margin-top: 10px;
    margin-right: 0;
  }
`;

const Header = ({
  prefixText = "",
  title = "",
  icon = null,
  filtrar = false,
  ordenar = false,
  search = false,
  searchValue = "",
  searchPlaceholder = "Pesquisar",
  onSearchChange,
  onFiltrar,
  onOrdenar,
  filterOptions = null,
  onFilterChange,
  acoes = null,
}) => {
  const [showFilterDropdown, setShowFilterDropdown] = useState(false);

  const handleFilterClick = () => {
    if (filterOptions) {
      setShowFilterDropdown((prev) => !prev);
      return;
    }
    onFiltrar?.();
  };

  const handleFilterSelect = (value) => {
    onFilterChange?.(value);
    setShowFilterDropdown(false);
  };

  return (
    <Wrapper>
      <Container>
        <LeftSection>
          {prefixText && <PrefixText>{prefixText}</PrefixText>}
          {icon && (
            <IconWrapper>
              {typeof icon === "string" ? (
                <img src={icon} alt="ícone" />
              ) : (
                icon
              )}
            </IconWrapper>
          )}
          {title && <Title>{title}</Title>}

          {filtrar && (
            <Button
              $withDropdown={Boolean(filterOptions)}
              onClick={handleFilterClick}
            >
              Filtrar
              {filterOptions ? (
                <span className="material-symbols-outlined">filter_list</span>
              ) : (
                <img src={filter} alt="Filtrar" />
              )}
              {filterOptions && showFilterDropdown && (
                <Dropdown>
                  {filterOptions.map((option) => (
                    <DropdownItem
                      key={option.label}
                      onClick={() => handleFilterSelect(option.value)}
                    >
                      {option.label}
                    </DropdownItem>
                  ))}
                </Dropdown>
              )}
            </Button>
          )}

          {ordenar && (
            <Button onClick={onOrdenar}>
              Ordenar
              <span className="material-symbols-outlined">toc</span>
            </Button>
          )}

          {acoes}
        </LeftSection>

        {search && (
          <SearchBarWrapper>
            <SearchBar
              placeholder={searchPlaceholder}
              value={searchValue}
              onChange={(event) => onSearchChange?.(event.target.value)}
            />
          </SearchBarWrapper>
        )}
      </Container>
    </Wrapper>
  );
};

export default Header;
